










import {ComputedRef, computed, defineComponent, onMounted, PropType} from '@vue/composition-api'
import {useActions, useGetters} from "vuex-composition-helpers"
import FavoriteHeartIcon from '@/apps/MyStudyChoiceHeartWidget/components/FavoriteHeartIcon.vue'
import InnerLoader from "@/shared/components/atoms/InnerLoader.vue"
import {Config} from "@/apps/MyStudyChoiceHeartWidget/models/config-viewmodel";


export default defineComponent({
    name: "MyStudyChoiceHeart",
    components: {
        FavoriteHeartIcon,
        InnerLoader
    },
    props: {
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props: { config: Config }) => {
        const {
            checkIsStudyChoiceStudyFavorite,
            setConfig,
            setStudyChoiceFavorite,
            deleteStudyChoiceFavorite
        } = useActions([
            'checkIsStudyChoiceStudyFavorite',
            'setConfig',
            'setStudyChoiceFavorite',
            'deleteStudyChoiceFavorite',
            'handleStatusCodes'
        ]);

        setConfig(props.config)

        const {
            checkIfFavorite, innerLoading
        } = useGetters([
            'checkIfFavorite',
            'innerLoading'
        ]);

        const heartIconType: ComputedRef<string> = computed((): string => {
            return checkIfFavorite.value ? 'fas' : 'fal'
        })

        const buttonText: ComputedRef<string> = computed((): string => {
            return checkIfFavorite.value ? props.config.labels.buttonTextFavorite : props.config.labels.buttonTextNotFavorite
        })

        onMounted(async () => {
            await checkIsStudyChoiceStudyFavorite();
        })

        const toggleAsFavorite = async () => {
            if (!checkIfFavorite.value) {
                await setStudyChoiceFavorite();
            } else {
                await deleteStudyChoiceFavorite();
            }
        }

        return {
            checkIfFavorite,
            heartIconType,
            innerLoading,
            buttonText,
            toggleAsFavorite
        }
    }
})
